export default __webpack_public_path__ + "static/media/BUTTONS.4f055fab.wav";